import { z } from 'zod';
const tableViewSchema = z.object({
    order: z.array(z.string()),
    hidden: z.array(z.string()),
    frozen: z.array(z.string()),
    widths: z.record(z.string(), z.number().int())
});
export const parseTableView = (value)=>{
    const parsed = tableViewSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
};
